import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { ErrorAudioBoxs } from "../../../../components/ErrorAudio/ErrorAudioBoxs"

class ModalError extends Component {
    render() {
        const { isOpen, onClose, error, dataError, isOpenDataErr, onClosePopup } = this.props
        ErrorAudioBoxs(error, isOpen, dataError, isOpenDataErr)

        return (
            <div className="ModalError">
                {
                    isOpenDataErr && dataError.length > 0 ? (
                        <Modal isOpen={isOpenDataErr} modalClassName="modalError" className="modal-container">
                            <ModalHeader>
                                <i className="fa fa-exclamation-circle text-danger mr-1" /> Lỗi:
                            </ModalHeader>
                            <ModalBody>
                                {
                                    dataError.map((item, index) => {
                                        return (
                                            <div className="text-danger text-large" key={index}>
                                                - <strong>#{item.barcode}:</strong> {item.message}
                                            </div>
                                        )
                                    })
                                }
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={onClosePopup}>Đóng </Button>
                            </ModalFooter>
                        </Modal>
                    ) : (
                        <Modal isOpen={isOpen} toggle={onClose} onClosed={onClose} className="modal-container">
                            <ModalHeader toggle={onClose}>Lỗi</ModalHeader>
                            <ModalBody>
                                <div className='font-size-lg'>
                                    {error !== '' && <p className='text-danger display-4'>{error}</p>}
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={onClose}>Đóng</Button>
                            </ModalFooter>
                        </Modal>
                    )
                }

            </div>
        )
    }
}

ModalError.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    error: PropTypes.string.isRequired
}

export default ModalError